import { REVIEW_PAGE_SECTIONS } from './ListingDetailConstants';

export const RECS = {
  AMENITIES: 'amenities',
  CONTACT: 'contact',
  APPLICATIONS: 'applications',
  DATE_AVAILABLE: 'dateAvailable',
  DESCRIPTION: 'description',
  HIDE_PHONE: 'hidePhone',
  HIDE_STREET_ADDRESS: 'hideStreetAddress',
  LEASE_TERMS: 'leaseTerms',
  PETS_NOT_ALLOWED: 'petsNotAllowed',
  PHOTOS: 'photos',
  ROOM_DESCRIPTION: 'roomAndSharedSpaceDescription',
  SCHEDULE: 'schedule',
  SECURITY_DEPOSIT: 'securityDeposit',
  SQUARE_FOOTAGE: 'squareFootage',
  VIRTUAL_TOUR: 'virtualTour',
  BUSINESS_HOURS: 'businessHours',
  FLOOR_PLAN_LAYOUT: 'floorPlanLayout',
  FLOOR_PLAN_PHOTOS: 'floorPlanPhotos',
  LAUNDRY: 'laundry',
  LEASE_LENGTH: 'leaseLength',
  NAME: 'name',
  PARKING: 'parking',
  PRICE: 'price',
  SPECIAL_OFFER: 'specialOffer',
  UNIT_AVAILABILITY: 'unitAvailability',
  WEBSITE: 'website',
  VIDEO: 'video',
  ONE_TIME_FEE: 'oneTimeFee',
  MONTHLY_FEE: 'monthlyFee',
} as const;

export const RECS_ARRAY_ORDER = {
  [REVIEW_PAGE_SECTIONS.BUILDING_DETAILS]: {
    [RECS.DESCRIPTION]: 0,
    [RECS.LEASE_TERMS]: 1,
    [RECS.WEBSITE]: 2,
    [RECS.BUSINESS_HOURS]: 3,
  },
  [REVIEW_PAGE_SECTIONS.POLICIES_AND_TERMS]: {
    [RECS.LEASE_LENGTH]: 0,
    [RECS.PETS_NOT_ALLOWED]: 1,
    [RECS.PARKING]: 2,
    [RECS.SECURITY_DEPOSIT]: 3,
  },
  [REVIEW_PAGE_SECTIONS.MEDIA]: {
    [RECS.PHOTOS]: 0,
    [RECS.VIRTUAL_TOUR]: 1,
    [RECS.VIDEO]: 2,
  },
};

export const REC_HEADINGS = {
  // oxlint-disable-next-line constellation-content/numbers
  [RECS.AMENITIES]: 'Add at least 3 amenities',
  [RECS.APPLICATIONS]: 'Receive Zillow applications',
  [RECS.CONTACT]: 'Share your contact information',
  [RECS.DATE_AVAILABLE]: 'Share when the rental is available',
  [RECS.ROOM_DESCRIPTION]: 'Describe the room and shared space',
  [RECS.DESCRIPTION]: 'Describe the property',
  [RECS.HIDE_PHONE]: 'Allow renters to contact you by phone',
  [RECS.HIDE_STREET_ADDRESS]: 'Show the property address',
  [RECS.LAUNDRY]: 'Describe the laundry situation',
  [RECS.LEASE_TERMS]: 'Share the lease terms',
  [RECS.PHOTOS]: 'Add at least 5 photos',
  [RECS.PRICE]: 'Add your pricing',
  [RECS.SCHEDULE]: 'Share your tour availability ',
  [RECS.SECURITY_DEPOSIT]: 'Provide your security deposit amount',
  [RECS.VIRTUAL_TOUR]: 'Add a 3D tour',
  [RECS.VIDEO]: 'Add videos',
  [RECS.PETS_NOT_ALLOWED]: 'Share your pet policy',
  [RECS.SQUARE_FOOTAGE]: 'Add your square footage',
  [RECS.WEBSITE]: 'Add your property’s website',
  [RECS.BUSINESS_HOURS]: 'Add your business hours',
  [RECS.FLOOR_PLAN_LAYOUT]: 'Add a floor plan layout',
  [RECS.FLOOR_PLAN_PHOTOS]: 'Add floor plan photos',
  [RECS.UNIT_AVAILABILITY]: 'Add unit-level availability',
  [RECS.SPECIAL_OFFER]: 'Add a special offer',
  [RECS.LEASE_LENGTH]: 'Share your lease length',
  [RECS.PARKING]: 'Share your parking options',
  [RECS.ONE_TIME_FEE]: 'Add a required one-time fee',
  [RECS.MONTHLY_FEE]: 'Add a required monthly fee',
};

export type RecHeadingKey = keyof typeof REC_HEADINGS;
export const isRecHeadingKey = (detail: string): detail is RecHeadingKey => detail in REC_HEADINGS;
